import React, { useRef, useState, useCallback } from 'react'

import Heading from '@react/react-spectrum/Heading'
import Textfield from '@react/react-spectrum/Textfield'
import Button from '@react/react-spectrum/Button'
import { error } from '@react/react-spectrum/Toast/js/ToastContainer'

import Copy from '@react/react-spectrum/Icon/Copy'
import Refresh from '@react/react-spectrum/Icon/Refresh'

import { getPreviewLink, useProject } from 'hooks'

import A from 'services/analytics'
import { getPreviewToken } from 'services/project'
import { copyInputByRef } from 'utils/clipboard'

function ShareProjectInput() {
  const websiteUrl = useRef()
  const [websiteAccessToken, setWebsiteAccessToken] = useState('')
  const { project } = useProject()

  const previewLink = getPreviewLink(project)

  const generateWebsiteUrl = useCallback(() => {
    A.triggerGenerateLink()
    getPreviewToken(project.meta.id)
      .then((token) => setWebsiteAccessToken(token || ''))
      .catch(() => error('Could not generate access token'))
  }, [project, setWebsiteAccessToken])

  const onCopy = () => copyInputByRef(websiteUrl)

  const websiteAccessUrl = websiteAccessToken ? ''.concat(previewLink, '?token=', websiteAccessToken) : ''

  return (
    <section>
      <Heading size='4'>Temporary Link</Heading>
      <p>
        It is ideal for short-lived demonstrations when link presentation is not a priority. It will expire in{' '}
        <b>30 days</b>.
      </p>
      <div className='temporary-link-preview'>
        <Textfield readOnly={true} value={websiteAccessUrl} ref={websiteUrl} />
        <Button variant='action' icon={<Copy />} onClick={onCopy} />
      </div>
      <Button variant='action' icon={<Refresh />} label='Generate Link' onClick={generateWebsiteUrl} />
    </section>
  )
}

export default function ShareProjectInputWrapper() {
  const { type } = useProject()
  if (
    !['customer-experience', 'customer-experience-v2', 'web', 'web-modular', 'customer-hub', 'web-social'].includes(
      type
    )
  ) {
    return null
  }

  return <ShareProjectInput />
}
